<template>
  <div class="vip-widget">
    <img
        :src="vipCirCleLineBg"
        class="vip-bg-line"
    />
    <div
        v-for="i in 6"
        :key="i"
        class="vip-circle"
        :style="getCircleStyle(i - 1)"
    >
      <div
          class="circle-dot"
          :style="{
          backgroundColor: getColor(i - 1),
        }"
      ></div>
      <div
          class="circle-text"
          :style="{
          color: getTextColor(i - 1),
        }"
      >
        VIP{{ vipStartIndex + i - 1 }}
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import {hcf} from "@/components/utils/HComFunctions.js";
  const vipCirCleLineBg = hcf.getNewGameUIIcon(`all_vip_level_bg_line.png`);

  const vipStartIndex = ref(0)
  const vipCurrentIndex = ref(0)

  const screenWidth = ref(window.innerWidth)

  const yPosList = computed(() => {
    return screenWidth.value <= 345
        ? [0.0, 13.5, 18, 18, 13.5, 0.0]
        : [0.0, 14, 20, 20, 14, 0.0]
  })

  function getColor(i) {
    return i === vipCurrentIndex.value - vipStartIndex.value
        ? '#DFAE36'
        : '#CFCFCF'
  }

  function getTextColor(i) {
    return i === vipCurrentIndex.value - vipStartIndex.value
        ? '#DFAE36'
        : 'rgba(255,255,255,0.5)'
  }

  function getCircleStyle(i) {
    const left = `${(i * screenWidth.value) / 6}px`
    const top = `${yPosList.value[i] + 14}px`
    const width = `${screenWidth.value / 6}px`
    return {
      position: 'absolute',
      left,
      top,
      width,
      textAlign: 'center',
    }
  }

  // 暴露方法供父组件调用
  function setCurLevel(newLevel, isLeft, maxLength) {
    vipCurrentIndex.value = newLevel;

    const visibleCount = 6;

    // 保证 newLevel 在显示的区间中间偏右（第3~4位）
    let newStart = newLevel - 2;

    // 防止越界
    if (newStart < 0) newStart = 0;
    if (newStart + visibleCount > maxLength) {
      newStart = maxLength- visibleCount;
    }

    vipStartIndex.value = newStart;
  }

  defineExpose({
    setCurLevel,
  })
</script>

<style scoped>
  .vip-widget {
    position: relative;
    width: 100%;
  }

  .vip-bg-line {
    width: 100%;
  }

  .circle-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0 auto 4px;
  }

  .circle-text {
    font-size: 12px;
  }
</style>
